import { render, staticRenderFns } from "./ConfigurationItem.vue?vue&type=template&id=54a16467&scoped=true&"
import script from "./ConfigurationItem.vue?vue&type=script&lang=js&"
export * from "./ConfigurationItem.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationItem.vue?vue&type=style&index=0&id=54a16467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a16467",
  null
  
)

export default component.exports